Ext.ns('mx.app.widget');

mx.app.widget.UpdateStyle = Ext.extend(mx.app.widget.UploadFile, {
    initComponent: function() {
        Ext.apply(this.labels, {
            windowTitle: 'Update style',
            resetLabel: 'Reset',
        });

        Ext.apply(this.handlers, {
            resetClick: function() {
                Ext.Msg.confirm(
                    'Reset style',
                    'Do you want to reset style by default?',
                    function(btn) {
                        if (btn == 'yes') {
                            mx.data.Ajax.request({
                                url: mx.PATH + MXAT.API('accounts/resetstyle/'),
                                params: this.params,
                                method: 'GET',
                                success: function(response) {},
                                scope: this,
                            });
                        }
                    },
                    this
                );
            },
        });

        mx.app.widget.UpdateStyle.superclass.initComponent.apply(this, arguments);

        this.addButton({text: this.labels.resetLabel}, this.handlers.resetClick, this);
    },
});
